import { DashboardContent } from '@fukuri-admins/ui/common';
import { Outlet } from 'react-router-dom';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { useConfiguration } from '../../../contexts/ConfigurationProvider';
import { OPEN_IN_NEW_ICON } from '../../../utils/constant';
import styles from './styles.module.scss';

export const DashboardLayout: React.FC = () => {
  const { applicationConfiguration, linkUrls } = useConfiguration();
  // TODO: contentの値を使って出しわけする
  const TITLES = ['運営会社', 'プライバシーポリシー', 'ご利用規約'];

  const footerLinks = linkUrls.map(linkUrl =>
    TITLES.includes(linkUrl.title) ? (
      <a key={linkUrl.url} href={linkUrl.url} target='_blank' rel='noopener noreferrer'>
        <span>{linkUrl.title}</span>
        <img src={OPEN_IN_NEW_ICON} alt='open_in_new' />
      </a>
    ) : null
  );

  return (
    <div className={styles.DashboardLayout}>
      <ClientSideMenu />
      <DashboardContent
        footerLinks={footerLinks}
        copyrightCompanyName={applicationConfiguration?.application_configuration?.partner?.name}
      >
        <Outlet />
      </DashboardContent>
    </div>
  );
};
